import axios from "axios";

export default {
  namespaced: true,
  state: {
    currencies: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    currenciesMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
    },
    RECEIVED_CURRENCIES(state, payload) {
      state.currencies = payload;
      state.isReceiving = false;
    },
    RECEIVING_CURRENCIES(state) {
      state.isReceiving = true;
    },
    RECEIVED_CURRENCY(state, payload) {
      state = Object.assign(state, {
        currencies: [...state.currencies, payload],
        isReceiving: false,
      })
    },
    RECEIVING_CURRENCY(state) {
      state.isReceiving = true;
    },
    UPDATED_CURRENCY(state, payload) {
      let index = state.currencies.findIndex(currency => currency._id === payload._id);
      state = Object.assign(state, {
        currencies: state.currencies.map((currency, i) => {
          if (i === index) {
            return Object.assign({}, currency, payload);
          }
          return currency;
        }),
        isUpdating: false,
        currenciesMessage: 'Currencies has been updating!',
      })
    },
    UPDATING_CURRENCY(state) {
      state.isUpdating = true;
    },
    DELETED_CURRENCY(state, payload) {
      let indexToDelete = state.currencies.findIndex(currency => currency._id === payload._id);
      let currencies = [...state.currencies];
      currencies.splice(indexToDelete, 1);
      state = Object.assign(state, {
        currencies: [...currencies],
        isDeleting: false,
        idToDelete: null,
        currenciesMessage: 'Currency has been Deleted!',
      });
    },
    DELETING_CURRENCY(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    deleteCurrencyRequest({dispatch}, payload) {
      dispatch("deletingCurrency", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/currency/' + payload._id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "delete", url: url,headers: headers})
      .then(function (response) {
        console.log(response.data);
        dispatch("deleteCurrency", {_id: payload._id});
      })
      .catch(function (error) {
        console.log(error.data);
      });
    },
    async deleteCurrencyListRequest({dispatch}, payload) {
      try{
        dispatch("deletingCurrency", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/currencylist/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deleteCurrency", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async deleteCurrencyRateRequest({dispatch}, payload) {
      try{
        dispatch("deletingCurrency", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/currencyrate/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deleteCurrency", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getCurrenciesRequest({dispatch}) {
      dispatch("receivingCurrencies");
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/get/currencies';
      var headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: headers})
      .then(response => {
        console.log('here', response.data)
        dispatch("receiveCurrencies", response.data);
      })
    },
    async insertCurrencyRequest({dispatch}, payload) {
      dispatch("receivingCurrency");
      let  token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/currency';
      let data = payload;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "post", url: url, headers: headers, data: data})
      .then((response)=> {
        dispatch("receiveCurrency", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });	
    },
    async insertCurrencyListRequest({dispatch}, payload) {
      try{
        dispatch("receivingCurrency");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/insert/currencylist/' + payload.currencyid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertCurrencyRateRequest({dispatch}, payload) {
      try{
        console.log(payload);
        dispatch("receivingCurrency");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/insert/currencyrate/' + payload.currencyid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        console.log(response.data)
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    updateCurrencyRequest({dispatch}, payload) {
      dispatch("updatingCurrency");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/currency/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "put", url: url,headers: headers,data: payload})
      .then(function (res) {
        dispatch("updateCurrency", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updateCurrencyRateRequest({dispatch}, payload) {
      try{
        dispatch("receivingCurrency");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/currencyrate/' + payload.currencyrateid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("receiveCurrency", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateCurrencyListRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let id = payload.id;
        delete payload['id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/currencylist/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    doNothing({commit}, payload) {
      commit("DO_NOTHING", payload)
    },
    receiveCurrencies({commit}, payload) {
      commit("RECEIVED_CURRENCIES", payload)
    },
    receivingCurrencies({commit}) {
      commit("RECEIVING_CURRENCIES")
    },
    receiveCurrency({commit}, payload) {
      commit("RECEIVED_CURRENCY", payload)
    },
    receivingCurrency({commit}) {
      commit("RECEIVING_CURRENCY")
    },
    updateCurrency({commit}, payload) {
      commit("UPDATED_CURRENCY", payload)
    },
    updatingCurrency({commit}) {
      commit("UPDATING_CURRENCY")
    },
    deleteCurrency({commit}, payload) {
      commit("DELETED_CURRENCY", payload)
    },
    deletingCurrency({commit}, payload) {
      commit("DELETING_CURRENCY", payload)
    }
  },
};
